import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@shared/ui/popover';

export const MMDDPicker = ({ value, onChange, disabled, error }: any) => {
  const [m = "", d = ""] = (value || "").split("-");
  const [openM, setOpenM] = useState(false);
  const [openD, setOpenD] = useState(false);

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const months = monthNames.map((name, i) => ({
    label: name,
    value: (i + 1).toString().padStart(2, '0')
  }));
  const days = Array.from({ length: 31 }, (_, i) => (i + 1).toString().padStart(2, '0'));

  const wrapperClass = `flex items-center w-full border border-gray-300 rounded-lg shadow-sm focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 bg-white overflow-hidden transition-colors ${
    error ? "border-red-500" : ""
  } ${disabled ? "opacity-50 cursor-not-allowed bg-gray-50" : ""}`;

  return (
    <div className={wrapperClass}>
      <Popover open={openM} onOpenChange={setOpenM}>
        <PopoverTrigger asChild>
          <button 
            type="button" 
            disabled={disabled}
            className="flex-[3] flex items-center justify-between py-2.5 px-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors focus:outline-none"
          >
            <span className={m ? "text-gray-900" : "text-gray-500"}>
              {m ? months.find(x => x.value === m)?.label : "MM"}
            </span>
            <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${openM ? "rotate-180" : ""}`} />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-48 p-2 z-[100]" align="start">
          <div className="grid grid-cols-3 gap-1">
            {months.map((month) => (
              <button
                key={month.value}
                type="button"
                onClick={() => {
                  onChange(`${month.value}-${d || '01'}`);
                  setOpenM(false);
                }}
                className={`py-2 px-1 text-sm rounded-md hover:bg-blue-50 transition-colors ${m === month.value ? "bg-blue-100 text-blue-700 font-medium" : "text-gray-700"}`}
              >
                {month.label}
              </button>
            ))}
          </div>
        </PopoverContent>
      </Popover>

      <span className="text-gray-300 font-medium px-1 select-none">/</span>

      <Popover open={openD} onOpenChange={setOpenD}>
        <PopoverTrigger asChild>
          <button 
            type="button" 
            disabled={disabled}
            className="flex-[2] flex items-center justify-between py-2.5 px-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors focus:outline-none"
          >
            <span className={d ? "text-gray-900" : "text-gray-500"}>
              {d ? parseInt(d, 10) : "DD"}
            </span>
            <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${openD ? "rotate-180" : ""}`} />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-64 p-2 z-[100]" align="start">
          <div className="grid grid-cols-4 gap-1">
            {days.map((day) => (
              <button
                key={day}
                type="button"
                onClick={() => {
                  onChange(`${m || '01'}-${day}`);
                  setOpenD(false);
                }}
                className={`py-1.5 px-1 text-sm rounded-md hover:bg-blue-50 transition-colors ${d === day ? "bg-blue-100 text-blue-700 font-medium" : "text-gray-700"}`}
              >
                {parseInt(day, 10)}
              </button>
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
